module.exports = __webpack_public_path__ + "static/media/Тезисы_УОМШ-2023, 2 том.9573a2f3.pdf";